import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import isClient from 'commons/isClient';
import LoginContainer from 'components/consumer/LoginSidebar/login-container';
import Impersonate from '../impersonate';
const LoginPage = props => {
  const $ = _c(9);
  const [overrideHash, setOverrideHash] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const params = queryString.parse(window.location.search);
      if (params.type === "override" && params.hash) {
        setOverrideHash(params.hash);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (overrideHash) {
    let t2;
    if ($[2] !== overrideHash) {
      t2 = <Impersonate hash={overrideHash} />;
      $[2] = overrideHash;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== props.history) {
    t2 = () => {
      const {
        redirect,
        ...search
      } = isClient() ? queryString.parse(window.location.search) : {};
      const params_0 = search ? queryString.stringify(search) : "";
      const targetUrl = redirect ? `${redirect}${params_0 ? `?${params_0}` : ""}` : isClient() && (window.location.pathname.startsWith("/customer") || window.location.pathname.startsWith("/quote")) ? window.location.pathname : "/";
      props.history.push(targetUrl);
    };
    $[4] = props.history;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.staticContext || $[7] !== t2) {
    t3 = <div className="md:w-[28rem] md:mx-auto md:my-16 md:border md:border-solid md:border-gray-light7"><LoginContainer isLoginPage={true} staticContext={props.staticContext} onLogin={t2} variant="login-page" /></div>;
    $[6] = props.staticContext;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
LoginPage.propTypes = {
  history: PropTypes.object,
  staticContext: PropTypes.object
};
export default withRouter(LoginPage);